// src/App.js
import React from "react";
import ChatWidget from "./ChatWidget";

function App() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #000 0%, #111 100%)",
        color: "#fff",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: "2rem",
      }}
    >
      {/* Header / Branding */}
      <header style={{ textAlign: "center", marginBottom: "2rem" }}>
        <h1
          style={{
            color: "#f0c000",
            fontSize: "2.2rem",
            fontWeight: "800",
            marginBottom: "0.5rem",
          }}
        >
          Tekuwami Assistant
        </h1>
        <p style={{ color: "#ccc", fontSize: "1.1rem" }}>
          Your AI-powered institutional support system ⚡
        </p>
      </header>

      {/* Chat Widget */}
      <ChatWidget />

      {/* Footer */}
      <footer
        style={{
          marginTop: "3rem",
          color: "#777",
          fontSize: "0.9rem",
          textAlign: "center",
        }}
      >
        © {new Date().getFullYear()} Tekuwami. All rights reserved.
      </footer>
    </div>
  );
}

export default App;
